import { toHref } from '@core/external-links/models';
import { getExtLinkEnv } from '@core/external-links/redux';
import { myMembershipAccount } from '@core/links/account';
import { useReduxState } from '@engage/redux/hooks';

export const useUpgradeMembershipPath = () => {
  const linkEnv = useReduxState(getExtLinkEnv);

  return toHref(myMembershipAccount, linkEnv);
};
